var OverlayProvider = /** @class */ (function () {
    function OverlayProvider(params, configuration) {
        this.action = null;
        this.entity = null;
        this.configuration = null;
        this.action = params.action || null;
        this.entity = params.entity || null;
        this.configuration = configuration;
    }
    return OverlayProvider;
}());
export { OverlayProvider };
